module.exports = __webpack_public_path__ + "img/cj.68da86e7.jpg";